// extracted by mini-css-extract-plugin
module.exports = {"btnContainer":"button_btnContainer__5LJhJ","btnText":"button_btnText__DijHW"};